import { makeSelectors } from '@utils/css';

const containerCls = "dibc6yjjzv";
const popperCls = "dibp18wophk";
const arrowCls = "dibae8x1hu";
const overlaySelectors = makeSelectors({
  container: containerCls,
  popper: popperCls,
  arrow: arrowCls
});

export { arrowCls, containerCls, overlaySelectors, popperCls };
import "./overlay.styles.linaria.module.css";
//# sourceMappingURL=overlay.styles.js.map
